import { system, Config } from "styled-system"

const configs: Config = {
	visibility: {
		property: "visibility"
	}
}

export const visibility = system(configs)
